<!-- 告警上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "",
                "mid": "",
                "aid": "",
                "CmdStr": "",
                "detail": ""
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报告警信息",
                urlPattern:this.commonUrls.third+"alert",
                precondition: "无",
                fitSystem: "VEMS传统停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编号' },
                        { info1: 'mid', info2: '是', info3: 'String', info4: '设备编号' },
                        { info1: 'aid', info2: '是', info3: 'Integer', info4: '告警编码' },
                        { info1: 'CmdStr', info2: '是', info3: 'String', info4: '告警标识, cmd=alert代表告警 cmd=recover 代表恢复' },
                        { info1: 'detail', info2: '是', info3: 'String', info4: '告警内容' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/alert.vue